// src/pages/DanhGiaCuoiKy/DanhGiaCuoiKyDesktop.js
import React, { useState } from "react";
import { XEP_LOAI_COLORS, XEP_LOAI_LABELS } from "./constants";

const DanhGiaCuoiKyDesktop = ({ filteredHS, danhGiaMap, onSelect }) => {
  const [page, setPage] = useState(1);
  const PER_PAGE = 15;
  const totalPages = Math.ceil(filteredHS.length / PER_PAGE);
  const paginated = filteredHS.slice((page - 1) * PER_PAGE, page * PER_PAGE);

  if (filteredHS.length === 0) {
    return <div className="bg-surface rounded-xl border border-outline-variant text-center py-16 text-on-surface-variant"><span className="material-symbols-outlined text-[64px]">inbox</span><p>Không có học sinh</p></div>;
  }

  return (
    <div className="bg-surface-container-lowest rounded-xl shadow-sm border border-outline-variant overflow-hidden">
      <table className="w-full text-left">
        <thead>
          <tr className="bg-surface-container-low border-b border-outline-variant">
            <th className="px-4 py-3 text-label-caps w-12">#</th>
            <th className="px-4 py-3 text-label-caps">Học sinh</th>
            <th className="px-4 py-3 text-label-caps">ĐTB</th>
            <th className="px-4 py-3 text-label-caps">CC</th>
            <th className="px-4 py-3 text-label-caps">Gợi ý</th>
            <th className="px-4 py-3 text-label-caps">Xếp loại</th>
            <th className="px-4 py-3 text-label-caps w-16">TT</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-outline-variant">
          {paginated.map((hs, idx) => {
            const dg = danhGiaMap[hs.id];
            const isDone = dg?.trangThai === 'daHoanThanh';
            return (
              <tr key={hs.id} onClick={() => onSelect(hs)}
                className={`hover:bg-surface-container-low cursor-pointer transition-colors ${isDone ? 'bg-green-50/30' : ''}`}>
                <td className="px-4 py-3 text-caption">{(page-1)*PER_PAGE + idx + 1}</td>
                <td className="px-4 py-3">
                  <div className="flex items-center gap-2">
                    <div className="w-8 h-8 rounded-full bg-primary-container text-on-primary-container flex items-center justify-center text-sm font-bold">{hs.hoTen?.charAt(0)}</div>
                    <span className="text-body-md font-semibold">{hs.tenThanh ? `${hs.tenThanh} ` : ''}{hs.hoTen}</span>
                  </div>
                </td>
                <td className="px-4 py-3 text-body-md font-bold">{dg?.diemTB > 0 ? dg.diemTB : '—'}</td>
                <td className="px-4 py-3 text-body-md">{dg?.chuyenCan > 0 ? `${dg.chuyenCan}%` : '—'}</td>
                <td className="px-4 py-3">
                  {dg?.goiYXepLoai ? (
                    <span className="px-2 py-0.5 rounded-full text-label-caps" style={{background: XEP_LOAI_COLORS[dg.goiYXepLoai]?.bg, color: XEP_LOAI_COLORS[dg.goiYXepLoai]?.text}}>
                      {XEP_LOAI_LABELS[dg.goiYXepLoai]}
                    </span>
                  ) : '—'}
                </td>
                <td className="px-4 py-3">
                  {dg?.xepLoai ? (
                    <span className="px-2 py-0.5 rounded-full text-label-caps font-bold" style={{background: XEP_LOAI_COLORS[dg.xepLoai]?.bg, color: XEP_LOAI_COLORS[dg.xepLoai]?.text}}>
                      {XEP_LOAI_LABELS[dg.xepLoai]}
                    </span>
                  ) : '—'}
                </td>
                <td className="px-4 py-3 text-center text-lg">{isDone ? '✅' : ''}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
      {totalPages > 1 && (
        <div className="px-4 py-3 border-t flex justify-between bg-surface-container-low text-caption">
          <span>{filteredHS.length} HS</span>
          <div className="flex gap-1">
            <button disabled={page===1} onClick={() => setPage(p=>p-1)} className="w-7 h-7 rounded border disabled:opacity-30">◀</button>
            <span className="px-2">{page}/{totalPages}</span>
            <button disabled={page===totalPages} onClick={() => setPage(p=>p+1)} className="w-7 h-7 rounded border disabled:opacity-30">▶</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default DanhGiaCuoiKyDesktop;